export interface GridParams {
  gridWidth: number
  gridHeight: number
  originLng: number
  originLat: number
  lngPerCol: number
  latPerRow: number
}

interface TrailSegment {
  coordinates: [number, number][]
}

function lngLatToGrid(lng: number, lat: number, params: GridParams): [number, number] {
  const col = Math.round((lng - params.originLng) / params.lngPerCol)
  const row = Math.round((lat - params.originLat) / params.latPerRow)
  return [col, row]
}

function bresenham(
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  mask: Uint8Array,
  width: number,
  height: number
): void {
  const dx = Math.abs(x1 - x0)
  const dy = Math.abs(y1 - y0)
  const sx = x0 < x1 ? 1 : -1
  const sy = y0 < y1 ? 1 : -1
  let err = dx - dy

  while (true) {
    if (x0 >= 0 && x0 < width && y0 >= 0 && y0 < height) {
      mask[y0 * width + x0] = 1
    }

    if (x0 === x1 && y0 === y1) break

    const e2 = 2 * err
    if (e2 > -dy) {
      err -= dy
      x0 += sx
    }
    if (e2 < dx) {
      err += dx
      y0 += sy
    }
  }
}

export function rasterizeTrails(trails: TrailSegment[], params: GridParams): Uint8Array {
  const { gridWidth, gridHeight } = params
  const mask = new Uint8Array(gridWidth * gridHeight)

  for (const trail of trails) {
    const coords = trail.coordinates
    if (coords.length < 2) continue

    let [prevCol, prevRow] = lngLatToGrid(coords[0][0], coords[0][1], params)

    for (let i = 1; i < coords.length; i++) {
      const [col, row] = lngLatToGrid(coords[i][0], coords[i][1], params)
      bresenham(prevCol, prevRow, col, row, mask, gridWidth, gridHeight)
      prevCol = col
      prevRow = row
    }
  }

  return mask
}
